The identifier for the `Location`.
